import { useEffect } from 'react';
import * as Sentry from '@sentry/browser';

import { useCurrentUser } from 'utils/hooks/globalState/baseState/useCurrentUser';
import { getSubdomain } from 'utils/browser';

export const useInitialiseSentry = () => {
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (currentUser) {
      const subdomain = getSubdomain();
      Sentry.setUser({ id: `${subdomain}_${currentUser.id}` });
    }
  }, [currentUser]);
};
